import notification from './feedback/notification';

const createNotification = (type, message, description) => {
  notification[type]({
    message: message ? message : "Server restarting, please try again later.",
    description,
  });
};
export default createNotification;
